import React from 'react';
import { registerWidget } from '@okapi/core';
import { BannersCarouselWidget, BannersCarouselWidgetData } from 'entries/common/widgets';
import { BannersResponse, SharedBannersResponse } from 'api/placements-api';
import { BannerEvent } from 'features/banners-carousel/types';
import { analyticsUtils } from 'utils/analytics-utils';
import { TrackingApi } from 'api/placements-api/tracking-api/tracking-api';
import { EnvState } from 'api/placements-api/tracking-api/types';

registerWidget<(SharedBannersResponse | BannersResponse) & EnvState, BannersCarouselWidgetData>(
  `${__NAME__}/banners-carousel`,
  serverData => {
    return data => {
      const { adaptiveMode, autoplay, gaName, gaPosition, loop, slidesPerView, targetBlank } = data;

      const contentIdClicked: string[] = [];
      const contentIdViewed: string[] = [];

      const trackingApi = serverData.env
        ? new TrackingApi(serverData.env.host, serverData.env.apiKey)
        : null;

      const getEventParams = (position: number) => ({
        elementType: 'banner',
        elementBlock: gaPosition,
        promotions: [
          {
            name: gaName,
            creative: 'monetization',
            position,
          },
        ],
      });

      const onImpressionContentClick = (e: BannerEvent) => {
        if (!contentIdClicked.includes(e.contentId)) {
          trackingApi?.impressionClickTracking(e.contentId);
          analyticsUtils.sendEvent('GA:promoClick', getEventParams(e.bannerPosition));
        }

        contentIdClicked.push(e.contentId);
      };

      const onImpressionContentView = (e: BannerEvent) => {
        if (!contentIdViewed.includes(e.contentId)) {
          trackingApi?.impressionViewTracking(e.contentId);
          analyticsUtils.sendEvent('GA:promoView', getEventParams(e.bannerPosition));
        }

        contentIdViewed.push(e.contentId);
      };

      return (
        <BannersCarouselWidget
          adaptiveImpression={serverData}
          {...{
            adaptiveMode,
            autoplay,
            loop,
            slidesPerView,
            targetBlank,
            onImpressionContentClick,
            onImpressionContentView,
          }}
        />
      );
    };
  }
);
